"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.rebrandFlags = void 0;
/**
 * Rebrand rollout flags for the 2026-09-01 reveal.
 *
 * Each field gates one slice. Flipping one to `true` is the entire release action for that
 * slice; reverting that one line is the rollback. Keep every flag in this object so the flip PR
 * stays a single-file diff that is trivial to review and to revert under pressure.
 *
 * These live in `packages/ui` rather than in each app because the Gatsby site and the Astro site
 * are both in production and must reveal simultaneously. Two copies of a flag can drift, and the
 * failure mode is a half-rebranded site on the morning of the launch.
 *
 * `as const` keeps each field a literal type, so the branch not taken is dropped at minification.
 *
 * Delete this module, and the legacy branch of every picker it gates, once the reveal has
 * stabilised.
 *
 * Reminder: the 404 page (`NotFound`) opts into the rebrand palette via a hardcoded
 * `isRebrandPalette` prop at its call sites rather than a flag here, because it cannot import this
 * module in Astro SSR yet (CommonJS). Add an `isRebrandPalette` flag below and wire the 404
 * consumers to it once that import works.
 */
exports.rebrandFlags = {
    isRebrandFooter: false,
    isRebrandHeader: false,
    isRebrandSignupModal: false,
    isRebrandTypography: false,
    isRebrandPageBackground: false,
    isRebrandPricing: false,
    isRebrandRouting: false,
};
